import { render, staticRenderFns } from "./Cheques-cartera.vue?vue&type=template&id=effda286&scoped=true"
import script from "./Cheques-cartera.vue?vue&type=script&lang=js"
export * from "./Cheques-cartera.vue?vue&type=script&lang=js"
import style0 from "./Cheques-cartera.vue?vue&type=style&index=0&id=effda286&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "effda286",
  null
  
)

export default component.exports